<div class="wk-dashboard-select__content">
    <div class="wk-dashboard-select__content-title">{{ "Settings.DashboardSelectionHeader" | translate }}</div>

    <div class="wk-dashboard-select__dropdown">
        <button class="wk-dashboard-select__dropdown-button" id="dashboardSelect" [disabled]="loadingDashboard" (click)="setDropdownState(true)">
            <div class="wk-dashboard-select__dropdown-title">{{ dashboardTitle }}</div>
            <wk-icon-chevron-right-sprite-pds3 />
            <wk-icon-chevron-up-sprite-pds3 />
            <wk-icon-chevron-down-sprite-pds3 />
            <icon-pds3 [name]="'wk-icon-chevron-' + (isDropdownOpen ? 'up' : 'down')" />
        </button>
        <dropdown-pds3 [targetSelector]="'#dashboardSelect'" [isOpen]="isDropdownOpen" (userRequest)="setDropdownState($event)">
            <dropdown-list-pds3 flowClass="wk-dashboard-select__dropdown-list">
                @for (item of dashboardItems; track $index) {
                    <dropdown-item-with-submenu-pds3
                        *dropdownListItemPds3
                        class="wk-dashboard-select__dropdown__item"
                        [class.selected]="item.label === selectedApp"
                    >
                        <div *dropdownListItemSubmenuLabelPds3 class="wk-dashboard-select__dropdown__item-title">
                            @if (item?.flavor && item?.flavor === "J&B") {
                                <div class="wk-dashboard-select__dropdown__item-icon">{{ lang === "en-CA" ? "JB" : "MF" }}</div>
                            } @else {
                                <div class="wk-dashboard-select__dropdown__item-icon">T1</div>
                            }
                            <div class="wk-dashboard-select__dropdown__item-label">{{ item.label }}</div>
                        </div>
                        @if (item?.flavor && item?.flavor === "J&B") {
                            <dropdown-list-pds3 *dropdownListItemSubmenuListPds3>
                                @for (dashboard of item.dashboards; track dashboard.id) {
                                    <dropdown-item-field-pds3
                                        *dropdownListItemPds3
                                        class="wk-dashboard-select__dropdown__item"
                                        [class.selected]="item.label === selectedApp && dashboard.name === selectedDashboard"
                                    >
                                        <button type="button" (click)="handleDashboardNameClick(dashboard)">
                                            {{ dashboard.name }}
                                        </button>
                                    </dropdown-item-field-pds3>
                                }
                            </dropdown-list-pds3>
                        } @else {
                            <dropdown-list-pds3 *dropdownListItemSubmenuListPds3>
                                @for (year of item.years; track $index) {
                                    <dropdown-item-with-submenu-pds3
                                        *dropdownListItemPds3
                                        class="wk-dashboard-select__dropdown__item"
                                        [class.selected]="item.label === selectedApp && year.label === selectedYear"
                                    >
                                        <div *dropdownListItemSubmenuLabelPds3>{{ year.label }}</div>
                                        <dropdown-list-pds3 *dropdownListItemSubmenuListPds3>
                                            @for (dashboard of year.dashboards; track dashboard.id) {
                                                <dropdown-item-field-pds3
                                                    *dropdownListItemPds3
                                                    class="wk-dashboard-select__dropdown__item wk-dashboard-select__dropdown__item__dashboard-name"
                                                    [class.selected]="
                                                        item.label === selectedApp &&
                                                        year.label === selectedYear &&
                                                        dashboard.name === selectedDashboard
                                                    "
                                                >
                                                    <button type="button" (click)="handleDashboardNameClick(dashboard)">
                                                        {{ dashboard.name }}
                                                    </button>
                                                </dropdown-item-field-pds3>
                                            }
                                        </dropdown-list-pds3>
                                    </dropdown-item-with-submenu-pds3>
                                }
                            </dropdown-list-pds3>
                        }
                    </dropdown-item-with-submenu-pds3>
                }
            </dropdown-list-pds3>
        </dropdown-pds3>
    </div>
    @if (loadingDashboard) {
        <app-loader [isOverlay]="false" size="large" />
    }
</div>
@if (showDashboardRenameOption === true) {
    <wk-settings-rename-dashboard [selectedDashboard]="currentDashboard" [class.loading]="loadingDashboard" />
}
